import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavbarControlComponent } from '../../shared/controls/navbar-control/navbar-control.component';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-privacy-policy',
    imports: [NavbarControlComponent],
    templateUrl: './privacy-policy.component.html',
    styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent implements OnInit {

    public privacy: string = null!;
    constructor(private titleService: Title,
        private _translateService: TranslateService,
        private _http: HttpClient,
    ) { }

    public ngOnInit(): void {

        let lang = this._translateService.currentLang || 'en';

        this._http.get<any>('./assets/i18n/static-content/privacy.json')
            .subscribe({
                next: res => {
                    this.privacy = res[lang]?.['privacy'];
                }
            });


        this.titleService.setTitle('ClockFlex - Privacy');
    }
}
